import { DialogContent, DialogOverlay } from '@radix-ui/react-dialog';
import { motion } from 'framer-motion';
import styled from 'styled-components';

// TODO: Can this use `Drawer`?

export const ModalOverlay = styled(motion(DialogOverlay))`
    && {
        background: linear-gradient(100deg, #17061c 40%, #060b33);
        transition: all ${({ theme }) => theme.transitions.speeds.normal}s;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: hidden scroll;
        box-sizing: border-box;

        // TODO: Fix z-index
        //Adding + 2 since NFT manager Sheet has z-index of 201
        z-index: ${({ theme }) => theme.zIndex.yatPage.nftFilterModal + 2};

        /* scrollbar styling */
        scrollbar-width: thin;
        scrollbar-color: ${({ theme }) => theme.colors.purple} transparent;
        ::-webkit-scrollbar {
            width: 0.1875rem;
        }
        ::-webkit-scrollbar-track {
            background: transparent;
        }
        ::-webkit-scrollbar-thumb {
            background: ${({ theme }) => theme.colors.purple};
        }
    }
`;

export const ModalContent = styled(motion(DialogContent))<{ children: React.ReactNode }>`
    && {
        outline: none;
        margin: 0;
        padding: 0;
        width: 100%;
        background: ${({ theme }) => theme.colors.transparent};

        @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
            position: absolute;
            top: 50%;
            left: 50%;
            margin: 0 auto;
        }
    }
`;

export const ModalContainer = styled.div`
    && {
        display: flex;
        flex-direction: column;
        margin: 0 25px;

        @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
            flex-direction: row;
            align-items: center;
            justify-content: center;
            margin: 0 8.333vw;
        }
    }
`;

export const Top = styled.div`
    && {
        display: flex;
        padding: 30px 0 10px 0;
        align-items: center;
        justify-content: center;
    }
`;

export const Filters = styled.div`
    && {
        /* padding-bottom: 21.5vw; */
        min-height: 100vh;
    }
`;

export const Actions = styled.div`
    && {
        display: flex;
        background: linear-gradient(100deg, #17061c 40%, #060b33);
        position: sticky;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 20px 0;
        gap: 10px;
    }
`;

export const SortDropdownWrapper = styled.div`
    padding-top: 20px;
    padding-bottom: 20px;
`;
